export default __webpack_public_path__ + "static/media/Error_Reproduccion_Video.2c777d2a.png";